import store from '../store/store';

export const getNativeAuth = () => {
  try {
    const { getAuth } = require('@react-native-firebase/auth');
    return getAuth();
  } catch (e) {
    return null;
  }
};

export const getNativeIdToken = async () => {
  try {
    const { getAuth, getIdToken } = require('@react-native-firebase/auth');
    const user = getAuth().currentUser;
    if (user) {
      return await getIdToken(user, true);
    }
  } catch (e) {
    // fall through
  }

  try {
    const { firebase } = require('../config/configureFirebase');
    const jsUser = firebase?.auth?.currentUser;
    if (jsUser?.getIdToken) {
      return await jsUser.getIdToken(true);
    }
  } catch (e) {
    // ignore
  }

  return null;
};

const getCurrentUid = (auth) => {
  if (auth?.currentUser?.uid) {
    return auth.currentUser.uid;
  }
  const profile = store.getState()?.auth?.profile;
  if (profile?.uid) {
    return profile.uid;
  }
  const nativeAuth = getNativeAuth();
  if (nativeAuth?.currentUser?.uid) return nativeAuth.currentUser.uid;
  return null;
};

export default getCurrentUid;
